import { useState } from "react";
import { LogoMark } from "./Logo";

const KEY = "kr_age_ok";

export function AgeGate({ children }) {
  const [ok, setOk] = useState(() => localStorage.getItem(KEY) === "1");
  const [left, setLeft] = useState(false);
  if (ok) return children;
  const confirm = () => {
    localStorage.setItem(KEY, "1");
    setOk(true);
  };
  return (
    <div data-testid="age-gate" className="fixed inset-0 z-[100] bg-[#FFF8EE] grid place-items-center px-6">
      <div className="max-w-md w-full text-center flex flex-col items-center gap-6">
        <LogoMark className="w-14 h-14" />
        <p className="eyebrow">Adults only · 18+</p>
        <h1 className="font-display text-4xl sm:text-5xl text-[#0E1B3D] leading-tight">Before you <span className="italic text-[#D7263D]">enter.</span></h1>
        <p className="text-sm text-[#26355A] leading-relaxed">This site contains content intended for adults. By entering you confirm you are at least 18 years old (or the age of majority where you live).</p>
        {left ? (
          <p data-testid="age-gate-denied" className="text-sm text-[#D7263D]">Sorry, you must be 18 or older to view this site.</p>
        ) : (
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <button data-testid="age-gate-confirm-btn" onClick={confirm} className="gold-btn flex-1 py-4 text-xs font-semibold tracking-[0.16em] uppercase">I'm 18 or older</button>
            <button data-testid="age-gate-exit-btn" onClick={() => setLeft(true)} className="ghost-btn flex-1 py-4 text-xs tracking-[0.16em] uppercase">Exit</button>
          </div>
        )}
      </div>
    </div>
  );
}
